eshopApp.controller('QuickCartController', ['$scope', '$http', '$cookies', 'alertMessage', 'quickModal', function($scope, $http, $cookies, alertMessage, quickModal){

	// Helpers
	$scope.helper = CustomNameSpace.helpers;

	$scope.display_cart = false;
	$scope.cart_products = null;
	$scope.cart_empty = null;
	$scope.spinner = true;

	// Get cart
	$scope.fetch = function() {

		$http.get('/a/get_cart').success(function(response){
			if(response.products) {
				$scope.cart_products = response.products;
				$scope.total = response.products.total;
				$scope.total_with_vat = response.products.total_with_vat;
				$scope.cart_empty = false;
			} else {
				$scope.cart_empty = true;
			}
		}).finally(function(){
			$scope.spinner = false;
		});
	}

	// Listen for changes to cookie and update cart (fetch data)
	$scope.$watch(function(){ return $cookies.get('cart_updated') }, function(){
		$scope.fetch();
	});

	// Remove from cart
	$scope.removeFromCart = function(product_id) {

		var modalInstance = quickModal.set('confirmation', generic.confirm, 'md');
		modalInstance.result.then(function(response) {
			if(response === 'ok') {
				$http.post('/a/remove_from_cart', {
					product_id : product_id
				}).success(function(response){
					if (response.message === 'deleted') {
						alertMessage.set(response.alert, 'success');
					} else {
						alertMessage.set(generic.error, 'error');
					}
				}).error(function(){
					alertMessage.set(generic.error, 'error');
				});
			}
		});
	}

	// Toggle cart
	$scope.toggleCart = function() {
		if ($scope.cart_products === null) {
			$scope.fetch();
		}
		if ($scope.display_cart === false) {
			$scope.display_cart = true;
		} else {
			$scope.display_cart = false;
		}
	}

}]);